import * as React from "react";

function SvgDropLocation(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 23" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.667 2.333a2 2 0 012-2h18.666a2 2 0 012 2V21a2 2 0 01-2 2H2.667a2 2 0 01-2-2V2.333zm20 9.334a8.667 8.667 0 11-17.334 0 8.667 8.667 0 0117.334 0zm-2 0a6.667 6.667 0 11-13.334 0 6.667 6.667 0 0113.334 0zM9.333 13a1.333 1.333 0 100-2.667 1.333 1.333 0 000 2.667zm0 1.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgDropLocation;
